<template>
  <div>
    <MainPage v-if="loaded">
      <div class="grid-links">
        <div class="grid-links-left">
          <router-link
            class="grid-link"
            :class="{ 'grid-link-full': card.size == 'full' }"
            v-for="(card, index) in gridLinksLeft"
            :key="index"
            :to="card.link"
          >
            <div
              class="grid-link__overlay"
              :style="{ backgroundColor: card.color }"
            ></div>
            <div
              class="grid-link__content d-flex flex-column justify-center align-center"
            >
              <div class="grid-link__title">{{ card.title }}</div>
              <div class="grid-link__description">
                {{ card.description }}
              </div>
            </div>
          </router-link>
        </div>
        <div v class="grid-links-right">
          <router-link
            class="grid-link"
            :class="{ 'grid-link-full': card.size == 'full' }"
            v-for="(card, index) in gridLinksRight"
            :key="index"
            :to="card.link"
          >
            <div
              class="grid-link__overlay"
              :style="{ backgroundColor: card.color }"
            ></div>
            <div
              class="grid-link__content d-flex flex-column justify-center align-center"
            >
              <div class="grid-link__title">{{ card.title }}</div>
              <div class="grid-link__description">
                {{ card.description }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </MainPage>
    <div class="chat-hubs" v-if="chatHubs">
      <div class="chat-hubs__header">
        <div class="chat-hubs__title">Chat Hubs</div>
        <a class="chat-hubs__rules" @click="rulesDialog = true">
          View Chat Rules
        </a>
      </div>

      <div class="chat-hubs__content">
        <div class="chat-hubs__image"></div>
        <div class="chat-hubs__items">
          <router-link
            class="chat-hubs__item"
            v-for="(item, index) in chatHubs"
            :key="index"
            :to="'/' + item.slug"
            :style="{ backgroundColor: item.chat_hub_color }"
          >
            <div class="chat-hubs__item-text">
              {{ item.heading_text }}: {{ item.intro_text }}
            </div>
            <v-btn icon color="white" class="chat-arrow">
              <v-icon size="51">$chat_arrow</v-icon>
            </v-btn>
          </router-link>
        </div>
      </div>
    </div>
    <v-dialog max-width="400" v-model="rulesDialog">
      <v-card>
        <v-card-text class="pa-6">
          <v-btn class="close" @click="rulesDialog = false" icon>
            <v-icon>$close</v-icon>
          </v-btn>
          <h2>Chat rules</h2>
          <br />
          <p>
            Welcome to the chat. This chat room will be open during video
            release periods to share reactions with others.
          </p>
          <p>
            This chat is a safe space for all attendees. Please see the rules of
            engagement below:
          </p>
          <ul>
            <li>
              Do not post personal contact information in the chat room (email,
              address, social, etc)
            </li>
            <li>Do not post links in the chat room</li>
            <li>
              Engaging in disturbing or inappropriate behavior will result in
              immediate removal from the chat room. (No warning required)
            </li>
            <li>
              Please respect the chat moderators. (Identified by * next to their
              names).
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

import MainPage from "./main.page";

export default {
  name: "HomePage",
  components: { MainPage },
  data() {
    return {
      loaded: false,
      rulesDialog: false,
    };
  },
  mounted() {
    this.setPageContext("home", () => {
      this.loaded = true;
    });
  },
  methods: {
    aspectRatio(card) {
      const aspectRatio = card.size == "full" ? 16 / 9 : 16 / 4.5;
      return ["xl", "lg", "md"].includes(this.$size) ? aspectRatio : undefined;
    },
  },
  computed: {
    gridLinksLeft() {
      return this.gridLinks?.filter((g) => g.side == "left") || [];
    },
    gridLinksRight() {
      return this.gridLinks?.filter((g) => g.side == "right") || [];
    },
    ...mapState({
      gridLinks: (state) => state.page.active?.grid_links,
    }),
    chatHubs() {
      return this.pages.filter((c) => c.is_chat_hub);
    },
  },
  //2.37
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.grid-links {
  position: relative;
  display: flex;
  padding: 0 120px;

  &-left,
  &-right {
    flex: 1;
    min-height: 360px;
    max-width: calc(50% - 10px);
  }
  &-right {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
  }
}

.grid-link {
  position: relative;
  text-decoration: none;
  display: block;

  &.grid-link-full {
    height: 100%;
  }

  &:not(.grid-link-full) {
    flex-basis: 50%;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &__overlay,
  &__bg {
    opacity: 0.8;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  &__overlay {
    opacity: 1;
  }

  &__bg {
    background-size: cover;
    background-position: center;
  }

  &__content {
    padding: 15px 55px;
    position: relative;
    height: 100%;
    text-align: center;
    color: white;
  }

  &__title {
    font-weight: 900;
    font-size: 64px;
    line-height: 64px;
    letter-spacing: -0.02em;
    margin-bottom: 13px;
  }

  &__description {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
  }
}

.chat-hubs {
  &__content {
    display: flex;
  }
  &__items {
    flex: 1;
  }
  &__image {
    background-image: url("~@/assets/chat-image.jpg");
    background-size: cover;
    background-position: 85% 50%;
    margin-right: 20px;
    &:before {
      content: "";
      display: block;
      width: 285px;
      height: 100%;
    }
  }
}

@media screen and (max-width: 960px) {
  .grid-links {
    flex-wrap: wrap;
    padding: 0 20px;

    &-left,
    &-right {
      flex-basis: 100%;
      margin-bottom: 18px;
      margin-left: 0;
      max-width: 100%;
    }
  }
  .grid-link {
    min-height: 175px;
    margin-bottom: 18px;

    &__title {
      font-size: 43px;
      line-height: 50px;
      font-weight: 700;
    }
  }

  .chat-hubs {
    &__content {
      flex-direction: column;
    }
    &__image {
      margin-right: 0;
      &:before {
        width: 100%;
        height: 236px;
      }
    }
  }
}
</style>
